import { VisitsJournalDatatable } from "datatables/visits_journal"
export default class VisitsJournalIndex extends ApplicationController {
  connect () {
    this.datatable = new VisitsJournalDatatable()
  }
}